'use client';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

export interface SelectedCollectionContextType {
  selectedCollection: string;
  setSelectedCollection(f: string | ((prev: string) => string)): void;
}

const SelectedCollectionContext = createContext<SelectedCollectionContextType>({} as SelectedCollectionContextType);

export const useSelectedCollection = () => {
  return useContext(SelectedCollectionContext);
};

export const SelectedCollectionProvider = ({ children }: { children: ReactNode }) => {
  const [selectedCollection, setSelectedCollection] = useState<string>('1');

  const values = useMemo<SelectedCollectionContextType>(() => {
    return {
      selectedCollection,
      setSelectedCollection
    } as SelectedCollectionContextType;
  }, [selectedCollection, setSelectedCollection]);

  return <SelectedCollectionContext.Provider value={values}>{children}</SelectedCollectionContext.Provider>;
};
